
<div *ngIf="!!topics?.length">
    <h3 class="underline-primary text-light font-weight-bold ml-0 mr-1 mb-0 pb-2">TOPICS</h3>
    <div class="row">
      <div class="py-1 px-2 col-sm-6 col-lg-4" *ngFor="let item of topics">
          <app-topic-item [topic]="item"></app-topic-item>
      </div>
    </div>

    <button type="button" *ngIf="!!lastEvaluatedKey" class="btn btn-link link-arrow more-results float-right text-right text-uppercase pr-0 mr-0" (click)="getNext()">
        More results<i class="icon icon-arrow-fwd-sm-link"></i>
    </button>
</div>
